<template>
  <div>
    <b-img class="img-paypal" src="/images/paypal.png" :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})" />
    <div class="wrap-btn-payment">
      <div id="paypal-button"></div>
      <br />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import VueScript2 from "vue-script2";
import { mapActions } from "vuex";
import * as actionType from "../../../controllers/ActionTypes";
import getEnv from '@/utils/env'

export default {
  name: "payPal",
  props: {
    formattedAmount: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      paymentId: "",
      payerId: "",
      loading: false
    };
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  methods: {
    ...mapActions("PaymentController", [actionType.PAY, actionType.PAYPAL]),
    processPayment() {
      var vm = this;
      paypal.Button.render(
        {
          env: getEnv('VUE_APP_PAYPAL_MODE'),
          payment: function(data, actions) {
            return vm
              .PAYPAL({ id: vm.orderId })
              .then(function(res) {
                return res.data.id;
              })
              .catch(function(error) {
                vm.$router.push({
                  name: "PaymentSuccess",
                  params: {
                    id: vm.orderId,
                    previousPendingPaymentId: vm.previousPendingPaymentId
                  }
                });
              });
          },
          onAuthorize: function(data, actions) {
            return vm
              .PAY({
                paypal_payment_id: data.paymentID,
                paypal_payer_id: data.payerID,
                user_payment_id: vm.orderId
              })
              .then(function(res) {
                vm.$router.push({
                  name: "PaymentSuccess",
                  params: {
                    id: vm.orderId,
                    previousPendingPaymentId: vm.previousPendingPaymentId
                  }
                });
              })
              .catch(function(error) {
                vm.$router.push({
                  name: "PaymentSuccess",
                  params: {
                    id: vm.orderId,
                    previousPendingPaymentId: vm.previousPendingPaymentId
                  }
                });
              });
          }
        },
        "#paypal-button"
      );
    }
  },
  mounted() {
    var vm = this;
    VueScript2.load("https://www.paypalobjects.com/api/checkout.js").then(
      function() {
        vm.processPayment();
      }
    );
  }
};
</script>